import { render, staticRenderFns } from "./Detalle_funcionario.vue?vue&type=template&id=27e205b0&scoped=true"
import script from "./Detalle_funcionario.vue?vue&type=script&lang=js"
export * from "./Detalle_funcionario.vue?vue&type=script&lang=js"
import style0 from "./Detalle_funcionario.vue?vue&type=style&index=0&id=27e205b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e205b0",
  null
  
)

export default component.exports